import React from 'react'

import { useTranslation } from 'react-i18next'

import portrait from '../../../assets/doctor-picture.webp'
import { SectionText } from '../../../components/SectionText'

interface AboutMeProps {
    className?: string
}

export const AboutMe: React.FC<AboutMeProps> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <div
            id="about-me"
            className={`${className} flex sm:flex-col justify-between h-auto max-h-[900px] w-full text-white
            sm:max-h-[1400px]
        `}>
            <div className="sm:w-full sm:h-3/5 w-2/3 h-full">
                <img
                    src={portrait}
                    alt="Portrait von Herrn Kreuzer"
                    className="h-full w-full object-cover object-top"
                    style={{ objectPosition: 'center 20%' }}
                />
            </div>
            <div
                className="bg-primary-blue w-1/3 h-full flex items-center justify-center px-3
                sm:w-full sm:h-2/5
            ">
                <SectionText
                    className="max-w-[300px]  xs:py-5 xs:px-5"
                    title="Jan-Henrik Kreuzer"
                    hrLineColor="bg-primary-green"
                    discoverMore={true}
                    discoverMoreLink="/about-me">
                    {t('landingPage.aboutMe')}
                </SectionText>
            </div>
        </div>
    )
}
